export enum CookingState {
  LOCKED = 0,
  ACQUIRED = 1,
  COOKED = 2,
}
